import { connect } from "react-redux";
import HeaderTitle from "header/components/title";

const mapStateToProps = () => {
  return {
    title: "Account suspended",
  };
};

export default connect(mapStateToProps)(HeaderTitle);
